import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import ProtectedRoute from './ProtectedRoute';
import LandingPageNew from '../pages/landing/LandingPageNew.jsx';

// Wait for session restoration before choosing the public or coach entry point.
const HomeRoute = () => {
  const { user, loading } = useAuth();
  if (loading || user) {
    return (
      <ProtectedRoute>
        <Navigate to="/productivity-coaching" replace />
      </ProtectedRoute>
    );
  }
  return <LandingPageNew />;
};

export default HomeRoute;
